import { createSlice } from '@reduxjs/toolkit';
import { fetchConstantDropdownAction } from '../../redux/actions/constantDropdownAction';

const initialState: any = {
	data: null,
	isLoading: true,
	error: null,
};

const ConstantDropdownSlice = createSlice({
	name: 'constantDropdown',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchConstantDropdownAction.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(
			fetchConstantDropdownAction.fulfilled,
			(state, action) => {
				state.isLoading = false;
				state.data = action?.payload?.data;
			}
		);
		builder.addCase(
			fetchConstantDropdownAction.rejected,
			(state, action: any) => {
				state.isLoading = false;
				state.error = action.payload;
			}
		);
	},
});

export default ConstantDropdownSlice;
